module.exports = __webpack_public_path__ + "img/20220423_162330.52b19fa4.jpg";